<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
    <!--   <router-link class="btn btn-orange" title="Back to settings" :to="{ path: '/settings'}"><i class="ti-arrow-left"></i> Back</router-link> -->
      <p></p>
      <user-form :route="route" @on-submit="onUserSubmit"></user-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import UserForm from './UserForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      UserForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        userModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.userModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Users/UserEdit.vue